import RestClient from '../RestClient/RestClient';
import { apiHosts } from '../RestClient/FetchHelper.config';
import { IRIS_MARKETING_SLOT_URL } from '../Common/CommonConstants';
import { getChannel } from '../Common/CommonHelper';

export const getMessageContent = () => {
    const requestParams = {
        searchTerm: 'cf-holidaybopismsg',
    };
    const context = RestClient.getContext();
    const channel = getChannel(context);
    const config = {
        url: `${IRIS_MARKETING_SLOT_URL}/s/cf-rewards`,
        apiHost: apiHosts.content,
        params: requestParams,
        excludeVersion: true,
        isCMHeaderRequired: false,
        isXCloudHeaderRequired: true,
        channel,
    };
    return RestClient.get(config).then((json) => json);
};

export const getCMMessageContent = () => {
    const requestParams = {
        searchTerm: 'cf-holidaybopismsg',
    };
    const context = RestClient.getContext();
    const channel = getChannel(context);
    const config = {
        url: `${IRIS_MARKETING_SLOT_URL}/s/ cf-holidaybopismsg `,
        apiHost: apiHosts.content,
        params: requestParams,
        excludeVersion: true,
        isXCloudHeaderRequired: true,
        isCMHeaderRequired: true,
        channel,
    };
    return RestClient.get(config)
        .then((json) => json)
        .catch((error) => {
            console.log(`request failed ${error}`);
        });
};
